// extracted by mini-css-extract-plugin
module.exports = {"title":"_4e5f713ae4--title--Qndyz"};